import React from "react";
import { useLocale } from "@insightfulscience/smart-react/i18";
import FormFooter, { FormFooterCol } from "@insightfulscience/atomic-react/r1/molecules/FormFooter";
import { FormSubmit } from "@insightfulscience/atomic-react/r1/atoms/FormSubmit";
import useFormAction from "@insightfulscience/smart-react/hooks/useFormAction";
import Spinner from "@insightfulscience/atomic-react/Spinner";
import FreeTrialBiologicsFormFields from "./FreeTrialBiologicsFormFields";
import { requestFreeTrialBiologics } from "./action";

const FreeTrialBiologicsForm = () => {
	const [t] = useLocale("free-trial-biologics-form");
	const [action, { isLoading }] = useFormAction(requestFreeTrialBiologics);

	return (
		<>
			{isLoading && <Spinner />}
			<FreeTrialBiologicsFormFields action={action}>
				<FormFooter>
					<FormFooterCol textAlign="left">
						<FormSubmit submitQASelector="free-trial-biologics-form-submit-btn">
							{t("SUBMIT")}
						</FormSubmit>
					</FormFooterCol>
				</FormFooter>
			</FreeTrialBiologicsFormFields>
		</>
	);
};

export default FreeTrialBiologicsForm;
